import Vue from "vue";
import VueI18n from "vue-i18n";

import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-TW";
import cnLocale from "element-ui/lib/locale/lang/zh-CN";

let default_lan = localStorage.getItem("AC_lan") || "EN";

Vue.use(VueI18n);

import en from "@/i18n/en";
import tw from "@/i18n/tw";
import cn from "@/i18n/cn";
import br from "@/i18n/br";

let messages = {
  EN: { ...en, ...enLocale },
  TW: { ...tw, ...zhLocale },
  CN: { ...cn, ...cnLocale },
  BR: { ...br, ...enLocale },
};

const i18n = new VueI18n({
  locale: default_lan,
  messages,
});

export default i18n;
